var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.slots.length > 0)?_c('div',{attrs:{"id":_vm.id}},_vm._l((_vm.slots),function(slot,index){return _c('banner',{key:index,style:(_vm.slots.length > 1 ? 'margin-bottom: 1rem;' : ''),attrs:{"value":slot,"label":index == 0 || _vm.labelAll ? _vm.label : null,"label-position":_vm.labelPosition,"wide":_vm.wide,"rendered":_vm.rendered}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }